import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

const DashboardPage = lazy(
  () => import("@/features/dashboard/DashboardPage")
);
const TreeViewPage = lazy(
  () => import("@/features/tree-view/TreeViewPage")
);
const PersonDetailPage = lazy(
  () => import("@/features/person-detail/PersonDetailPage")
);
const FamilyViewPage = lazy(
  () => import("@/features/family-view/FamilyViewPage")
);
const ImportPage = lazy(() => import("@/features/import/ImportPage"));
const PrintPage = lazy(() => import("@/features/print/PrintPage"));
const SettingsPage = lazy(
  () => import("@/features/settings/SettingsPage")
);
const GroupsPage = lazy(() => import("@/features/groups/GroupsPage"));
const PeoplePage = lazy(() => import("@/features/people/PeoplePage"));
const LoginPage = lazy(() => import("@/features/login/LoginPage"));

export const routes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: "people",
        element: <PeoplePage />,
      },
      {
        path: "tree/:treeId",
        element: <TreeViewPage />,
      },
      {
        path: "tree/:treeId/person/:personId",
        element: <PersonDetailPage />,
      },
      {
        path: "tree/:treeId/family/:familyId",
        element: <FamilyViewPage />,
      },
      {
        path: "tree/:treeId/settings",
        element: <SettingsPage />,
      },
      {
        path: "tree/:treeId/groups",
        element: <GroupsPage />,
      },
      {
        path: "import",
        element: <ImportPage />,
      },
      {
        path: "print",
        element: <PrintPage />,
      },
    ],
  },
];
